<template>
  <el-container style="height: calc(100vh - 273px);">
    <el-aside :width="asideWidth">
      <div class="components">
        <div v-for="(group, i) in baseComponents" :key="i">
          <p class="group-name">{{ group.name }}</p>
          <ul>
            <draggable class="drag" :list="group.components" :options="{ sort: false }" :group="{ name: 'form', pull: 'clone', put: false }" @start="isStart = true" @end="isStart = false"
              :clone="clone">
              <li v-for="(cp, id) in group.components" :key="id">
                <i :class="cp.icon"></i>
                <span>{{ cp.title }}</span>
              </li>
            </draggable>
          </ul>
        </div>
      </div>

    </el-aside>

    <el-main class="layout-main">
      <!-- <div class="tool-nav">
        <div>
          <el-tooltip class="item" effect="dark" content="撤销" placement="bottom-start">
            <i class="el-icon-refresh-left"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="恢复" placement="bottom-start">
            <i class="el-icon-refresh-right"></i>
          </el-tooltip>
        </div>
        <div>
          <el-tooltip class="item" effect="dark" content="预览表单" placement="bottom-start">
            <i class="el-icon-view" @click="viewForms"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="移动端" placement="bottom-start">
            <i :class="{'el-icon-mobile':true, 'select': showMobile}" @click="showMobile = true"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="PC端" placement="bottom-start">
            <i :class="{'el-icon-monitor':true, 'select': !showMobile}" @click="showMobile = false"></i>
          </el-tooltip>
        </div>
      </div> -->
      <div class="work-form">
        <div :class="{ 'mobile': showMobile, 'pc': !showMobile }">
          <div :class="{ 'bd': showMobile }">
            <div :class="{ 'form-content': showMobile }">
              <div class="form">
                <div class="tip" v-show="forms.length === 0 && !isStart">拖拽左侧控件至此</div>
                <!-- 列表长度: {{ forms.length }} -->
                <draggable class="drag-from" :list="forms" group="form" :options="{ animation: 300, chosenClass: 'choose', sort: true }" @start="startDrag" @end="endDrag" @change="dragItem">

                  <div v-for="(item, index) in forms" :key="index" class="form-item" @click="selectItem(item)" :style="getSelectedClass(item)">
                    <div class="form-header">
                      <p>
                        <span v-if="item.props.required">*</span>{{ item.title }}
                      </p>
                      <div class="option">
                        <!-- 入职日期不可以复制 -->
                        <div v-if="item.name!=='JoinDate'" class="icon-copy" @click.stop="copy(item, index)"></div>
                        <div class="icon-close" @click.stop="del(index)"></div>
                      </div>
                      <form-design-render :config="item" />
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>

    <el-aside class="layout-param" :width="asideWidth">
      <div class="tool-nav-r" v-if="selectFormItem">
        <!-- <i :class="selectFormItem.icon" style="margin-right: 5px; "></i> -->
        <span>{{ formItemTitle(selectFormItem.icon) }}配置区</span>
        <!-- <span>{{ selectFormItem.title }}配置区</span> -->
      </div>
      <div v-if="!selectFormItem || forms.length === 0" class="tip">
        <!-- 😀 选中控件后在这里进行编辑 -->
      </div>
      <div v-else class="form-config">
        <form-component-config />
      </div>
    </el-aside>
    <el-dialog clickClose closeFree width="800px" :showFooter="false" :border="false" title="表单预览" v-model="viewFormVisible">
      <form-render ref="form" :forms="forms" v-model="formData" />
    </el-dialog>
  </el-container>
</template>

<script>
import draggable from "vuedraggable";
import FormRender from '@/pages/officeApproval/common/form/FormRender'

import FormDesignRender from '@/pages/officeApproval/common/layout/FormDesignRender'
import FormComponentConfig from '@/pages/officeApproval/common/form/FormComponentConfig'
import { baseComponents } from '@/pages/officeApproval/common/form/ComponentsConfigExport'

export default {
  name: "FormDesign",
  components: { draggable, FormComponentConfig, FormDesignRender, FormRender },
  data() {
    return {
      formData: {},
      libSelect: 0,
      viewFormVisible: false,
      isStart: false,
      showMobile: true,
      baseComponents,
      select: null,
      drag: false,
      asideWidth: '400px',
      // forms:this.$store.state.design.formItems
    }
  },
  computed: {
    forms: {
      get() {
        return this.$store.state.design.formItems
      },
      set(val) {
        this.$store.commit('updatesDesignForms', val)
      }
    },
    selectFormItem: {
      get() {
        return this.$store.state.selectFormItem
      },
      set(val) {
        this.$store.commit('updatesSelectFormItem', val)
      }
    },
    nodeMap() {
      return this.$store.state.nodeMap
    },
  },
  mounted() {
    this.updateAsideWidth();
    window.addEventListener('resize', this.updateAsideWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateAsideWidth);
  },
  methods: {
    startDrag(e) {
      this.drag = true;
    },
    endDrag(e) {
      this.drag = false;
    },
    dragItem(e) {
      // 拖拽新增控件的时，设为选中
      console.log('>>',e)
      if (e.added) {
        const element = e.added.element;
        if (element) {
          this.$store.commit('updatesSelectFormItem', element);
        }
      }
      // else if (e.moved) {
      //   const element = e.moved.element;
      //   if (element) {
      //     this.selectItem(element)
      //     this.$store.commit('updatesSelectFormItem', element);
      //   }
      // }
    },
    updateAsideWidth() {
      const screenWidth = document.documentElement.clientWidth || window.innerWidth;
      this.asideWidth = screenWidth > 1600 ? '400px' : '300px';
    },
    copy(node, index) {
      console.log('>>', node, index)
      // 这里使用深度复制
      const newNode = this.$deepCopy(node)
      newNode.id = this.getId()
      newNode.title += '-复制'
      this.$store.commit('insertFormItem', { index: index + 1, item: newNode })
    },
    getId() {
      return 'field' + (Math.floor(Math.random() * (99999 - 10000)) + 10000).toString()
        + new Date().getTime().toString().substring(5)
    },
    del(index) {
      this.$confirm('删除组件将会连带删除包含该组件的条件以及相关设置，是否继续?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        // 如果删除的是当前选中的组件，清空配置
        const currentFormItem = this.forms[index];
        if (this.selectFormItem && currentFormItem.id === this.selectFormItem.id) {
          this.$store.commit('updatesSelectFormItem', null);
        }
        if (this.forms[index].name === 'SpanLayout') {
          // 删除的是分栏则遍历删除分栏内所有子组件
          this.forms[index].props.items.forEach(item => {
            this.removeFormItemAbout(item)
          })
          this.$store.commit('CLEAR_SPAN_LAYOUT_ITEMS', index)
        } else {
          this.removeFormItemAbout(this.forms[index])
        }
        this.$store.commit("removeFormItem", index);
        // this.forms.splice(index, 1)
        // this.$store.commit('REMOVE_FORM_ITEM', index)
      })
    },
    removeFormItemAbout(item) {
      this.nodeMap.forEach(node => {
        // 搜寻条件，进行移除
        if (node.type === 'CONDITION') {
          node.props.groups.forEach(group => {
            const i = group.cids.remove(item.id)
            if (i > -1) {
              // 从子条件移除
              this.$store.commit('REMOVE_CONDITION', { groupId: group.id, index: i })
            }
          })
        }
        //搜寻权限，进行移除
        if (node.type === 'ROOT' || node.type === 'APPROVAL' || node.type === 'CC') {
          node.props.formPerms.removeByKey('id', item.id)
          if (node.props.formUser === item.id) {
            node.props.formUser = ''
          }
        }
      })
    },
    clone(obj) {
      obj.id = this.getId()
      return JSON.parse(JSON.stringify(obj));
    },
    viewForms() {
      this.viewFormVisible = true
    },
    selectItem(cp) {
      this.selectFormItem = cp
    },
    getSelectedClass(cp) {
      return this.selectFormItem && this.selectFormItem.id === cp.id ?
        'background-color: #F8FAFA;box-shadow: 0px 3px 12px 1px rgba(47,48,48,.1);' : ''
    },
    validateItem(err, titleSet, item) {
      // if (titleSet.has(item.title) && item.name !== 'SpanLayout') {
      //   err.push(`表单 ${item.title} 名称重复`)
      // }
      if (item.name !== 'Description' && item.name !== 'SpanLayout') {
        if (titleSet.has(item.title)) {
          err.push(`表单 ${item.title} 名称重复`);
        }
      }
      titleSet.add(item.title);
      if (item.name === 'SelectInput' || item.name === 'MultipleSelect') {
        if (item.props.options.length === 0) {
          err.push(`${item.title} 未设置选项`)
        }
      } else if (item.name === 'TableList') {
        if (item.props.columns.length === 0) {
          err.push(`明细表 ${item.title} 内未添加组件`)
        }
      } else if (item.name === 'SpanLayout') {
        if (item.props.items.length === 0) {
          err.push('分栏内未添加组件')
        } else {
          item.props.items.forEach(sub => this.validateItem(err, titleSet, sub))
        }
      }
    },
    validate() {
      let err = []
      if (this.forms.length > 0) {
        let titleSet = new Set()
        this.forms.forEach(item => {
          //主要校验表格及分栏/选择器/表单名称/是否设置
          this.validateItem(err, titleSet, item)
        })
      } else {
        err.push('表单为空，请添加组件')
      }
      return err
    },
    // 通过icon返回标题
    formItemTitle(icon) {
      for (const group of this.baseComponents) {
        const component = group.components.find(cp => cp.icon === icon);
        if (component) {
          return component.title;
        }
      }
      return '';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_tokens.scss";

// .choose {
// border: 1px dashed @theme-primary !important;
// }

.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
  }
}


.components {
  overflow-x: hidden;
  overflow-y: scroll;
  //margin-top: 20px;
  //padding: 0 20px;
  font-size: 14px;
  width: 100%;
  height: 100%;

  .group-name {
    height: 70px;
    font-weight: bold;
    font-size: 16px;
    color: #2F3030;
    padding-top: 30px;
    box-sizing: border-box;
  }

  .drag {
    // margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    li {
      background: #F8FAFA;
      border-radius: 4px;
      text-align: center;
      display: flex;
      align-items: center;
      width: calc(50% - 12px);
      height: 44px;
      margin-bottom: 12px;
      color: #2F3030;
      cursor: grab;
      box-sizing: border-box;
      border: 1px solid #F8FAFA;

      &:hover {
        border: 1px solid $primaryColor;
        // background-color: rgba($color: $primaryColor, $alpha: .1);
      }

      i {
        margin: 0 4px 0 11px;
      }
    }

    li:nth-child(odd) {
      margin-right: 12px;
    }
  }
}

/deep/ .el-main {
  padding: 0;
}

.layout-main {
  background-color: #feffff;

  .tool-nav {
    font-size: medium;
    padding: 8px 20px;
    background: #fafafb;
    border-bottom: 1px solid #ebecee;

    div:first-child {
      display: inline-block;
      text-align: left;

      i {
        margin-right: 10px
      }
    }

    div:last-child {
      float: right;

      i {
        margin-left: 10px
      }
    }

    i {
      color: #7a7a7a;
      cursor: pointer;

      &:hover {
        color: #4b4b4b;
      }
    }
  }

  .work-form {
    margin: 0 auto;
    height: calc(100vh - 273px);
    overflow-y: auto;
    // background: red;
    // border-left: 1px solid rgb(235, 236, 238);
    // border-right: 1px solid rgb(235, 236, 238);

    .pc {
      margin-top: 4%;

      .drag-from {
        height: calc(100vh - 190px);
        background-color: rgb(245, 246, 246);

        .form-item,
        li {
          cursor: grab;
          background: #ffffff;
          padding: 10px;
          // border: 1px solid #ebecee;
        }
      }
    }

    .mobile {
      height: 100%;
      // margin-left: auto;
      // margin-right: auto;
      // width: 360px;
      // max-height: 640px;
      // margin-top: 4%;
      // border-radius: 24px;
      // box-shadow: 0 8px 40px 0 rgba(17, 31, 44, 0.12);

      .bd {
        height: 100%;
        // border: 1px solid rgba(17, 31, 44, 0.08);
        // border-radius: 24px;
        // padding: 10px 10px;
        // background-color: #ffffff;

        .form-content {
          height: 100%;
          // padding: 3px 2px;
          // border-radius: 14px;
          // background-color: #f2f4f5;

          .drag-from {
            width: 100%;
            // height: calc(100vh - 190px);
            min-height: 200px;
            // height: 100%;
          }

          .form {
            overflow-y: auto;
            width: 100%;
            display: inline-block;
            // max-height: 640px;
            height: 100%;
            box-sizing: border-box;
            padding: 70px 0;

            li {
              list-style: none;
              background: #F8FAFA;
              padding: 16px 0 16px 32px;
              margin: 0 16px 24px;
              cursor: grab;
              font-size: 14px;
              color: #2F3030;

            }

            .form-item {
              background-color: #ffffff;
              background-image: url('~@/pages/officeApproval/common/icon/icon-move.png');
              background-repeat: no-repeat;
              background-position: 0 18px;
              background-size: 20px 20px;
              padding: 0 90px 16px 32px;
              margin: 0 16px 24px;
              cursor: grab;

            }
          }
        }
      }
    }

    .tip {
      //float: left;
      margin: 0 auto;
      // width: 65%;
      // max-width: 400px;
      // padding: 35px 20px;
      // border-radius: 10px;
      // border: 1px dashed rgba(25, 31, 37, 0.12);
      // margin-top: 50px;
      text-align: center;
      font-size: 18px;
      color: #C5C9C9;
      z-index: 9999;
      line-height: 200px;

      // &:hover {
      // border: 1px dashed @theme-primary;
      // }
    }
  }

}

.layout-param {
  text-align: center;
  font-size: 14px;
  color: rgb(122, 122, 122);

  .tool-nav-r {
    // text-align: left;
    // font-size: small;
    // border-left: 1px solid #ebecee;
    // padding: 10px 20px;
    // background: #fafafb;
    // border-bottom: 1px solid #ebecee;
    font-size: 16px;
    color: #2F3030;
    font-weight: bold;
    text-align: left;
    height: 70px;
    box-sizing: border-box;
    padding: 30px 0 0 16px;
  }

  .tip {
    margin-top: 150px;
  }
}

.form-config {
  text-align: left;
  padding: 0 16px;

  /deep/ {
    // .el-form-item {
    // margin-bottom: 24px;
    // }

    .el-form-item__label {
      padding: 0;
      height: 28px;
      line-height: 28px;
      color: #2F3030;
      font-size: 14px;
    }

    .el-input__inner,
    .el-textarea__inner {
      padding-left: 8px;
    }

  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

// .select {
// color: @theme-primary !important;
// color: #4b4b4b !important;
// }

.form-header {
  font-size: small;
  color: #2F3030;
  text-align: left;
  position: relative;
  // background-color: #fff;

  p {
    // position: relative;
    height: 44px;
    box-sizing: border-box;
    padding-top: 16px;

    span {
      // position: absolute;
      // left: -8px;
      // top: 3px;
      color: rgb(217, 0, 19);
      display: inline-block;
      margin-right: 4px;
    }
  }

  .option {
    position: absolute;
    top: 16px;
    right: -90px;
    display: inline-flex;
    justify-content: flex-end;

    .icon-copy {
      width: 16px;
      height: 16px;
      margin-right: 16px;
      background-image: url('~@/pages/officeApproval/common/icon/icon-fuzhi.png');
      cursor: pointer;
    }

    .icon-close {
      width: 16px;
      height: 16px;
      margin-right: 16px;
      background-image: url('~@/pages/officeApproval/common/icon/icon-del.png');
      cursor: pointer;
    }

    // i {
    //   font-size: large;
    //   cursor: pointer;
    //   color: #8c8c8c;
    //   padding: 5px;
    //   &:hover{
    //     color: #f56c6c;
    //   }
    // }
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #EDF2F2;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}

%defaultIcon {
  width: 20px;
  height: 20px;
}

$iconList: danhang duohang danxuan duoxuan shuzi shuoming riqi riqiqujian tupian dianhua fujian bumen jine shengshiqu person ruzhi;

@for $i from 1 through length($iconList) {
  .icon-#{nth($iconList,$i)} {
    @extend %defaultIcon;
    background-image: url('~@/pages/officeApproval/common/icon/icon-#{nth($iconList,$i)}.png');
  }
}

.drag-from /deep/ {

  .form-item .el-input,
  .form-item .el-select {
    width: 100%;
  }

  .el-textarea.is-disabled .el-textarea__inner,
  .el-input.is-disabled .el-input__inner {
    background-color: #ffffff;

  }
}
</style>
